const style = {
  container: {
    width: "100vw",
    minHeight: "100vh", // Alterado de height para minHeight
    backgroundImage: "url('./page_pag.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center", 
    overflowY: "auto",
    overflowX: "hidden",
    padding: "20px 0",
    boxSizing: "border-box",
  },
  containerBackFilter: {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    background: "rgba(0,0,0,0.4)",
    zIndex: 1,
  },
  content: {
    zIndex: 2,
    width: "100%",
    minHeight: "100%", // Alterado de height para minHeight
    alignItems: "center",
    justifyContent: "center",
    overflowX: "hidden",
    flexDirection: "column",
    display: "flex",
    padding: "20px 0", // Adicionado padding para espaçamento
  },
  aiaiai: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: 10,
    width: "100%",
    marginBottom: 20,
    flexWrap: "wrap"
  },
  aiaiaiImage: {
    width: 100
  },
  aiaiaiTitleBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center"
  },
  aiaiaiTitle: {
    fontSize: "2rem",
    fontWeight: 600,
    color: "white"
  },
  aiaiaiSubTitle: {
    fontSize: "1.6rem",
    fontWeight: 400,
    color: "white"
  },
  boxes: {
    alignItems: "center",
    justifyContent: "center",
    height: "max-content",
    gap: 20,
    display: "flex",
    flexWrap: "wrap",
    padding: "20px 0", // Adicionado padding para espaçamento
  },
  box: {
    width: 350,
    minHeight: 350,
    background: "white",
    display: "grid",
    gridTemplateRows: "auto 40px",
    boxSizing: "border-box",
  },
  boxFirstContent: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    boxSizing: "border-box",
    padding: "30px 10px",
  },
  boxTitle: {
    width: "100%",
    textAlign: "center",
    fontSize: 22,
    fontWeight: 600,
    color: "rgba(226, 160, 58, 1)",
  },
  beneficiaryBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  beneficiaryBoxTitle: {
    fontSize: 22,
    color: "rgba(80, 80, 80, 1)",
    fontWeight: 600,
    marginTop: 10,
  },
  benediciaryBoxName: {
    fontSize: 22,
    color: "rgba(80, 80, 80, 1)",
    fontWeight: 200,
  },
  benediciaryBoxCnpj: {
    fontSize: 18,
    color: "rgba(80, 80, 80, 1)",
    fontWeight: 200,
  },
  copyButton: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    cursor: "pointer",
    alignItems: "center",
    color: "white",
    fontSize: 20,
    fontWeight: 600,
    background: "rgba(226, 160, 58, 1)",
  },
  accountInfo: {
    marginTop: 20,
    display: "flex",
    flexDirection: "column",
    gap: 5,
    alignItems: "center",
  },
  accountInfoBox: {
    width: "100%",
    display: "flex",
    textAlign: "center",
    justifyContent: "center",
    gap: 2,
  },
  accountInfoBoxName: {
    fontSize: 18,
    fontWeight: 600,
    color: "rgba(80, 80, 80, 1)",
  },
  accountInfoBoxValue: {
    fontSize: 16,
    fontWeight: 200,
    color: "rgba(80, 80, 80, 1)",
    // textDecoration: "underline"
  },
};

export default style;
